import React from 'react';

const Difficulty = ({ block }) => {
  return (
    <div className={`difficulty difficulty-${block.text}`} style={{ textTransform: 'capitalize' }}>
      {block?.text?.split('-').join(' ')}
    </div>
  );
};

export default Difficulty;
